import api from "../../services/api";

const BASE_URL = "/api/v1/digital-files";

// Personal Information Services
export const personalInfoService = {
  // Create or update personal information
  createOrUpdatePersonalInfo: async (employeeId, personalInfoData) => {
    const response = await api.post(
      `${BASE_URL}/personal-info/${employeeId}`,
      personalInfoData
    );
    return response.data;
  },

  // Get personal information by employee ID
  getPersonalInfo: async (employeeId) => {
    const response = await api.get(`${BASE_URL}/personal-info/${employeeId}`);
    return response.data;
  },

  // Get all personal information (admin/HR)
  getAllPersonalInfo: async (params = {}) => {
    const response = await api.get(`${BASE_URL}/personal-info`, { params });
    return response.data;
  },

  // Update specific field
  updatePersonalInfoField: async (employeeId, fieldData) => {
    const response = await api.put(
      `${BASE_URL}/personal-info/${employeeId}/field`,
      fieldData
    );
    return response.data;
  },

  // Delete personal information
  deletePersonalInfo: async (employeeId) => {
    const response = await api.delete(
      `${BASE_URL}/personal-info/${employeeId}`
    );
    return response.data;
  },
};

// Job History Services
export const jobHistoryService = {
  // Create job history entry
  createJobHistory: async (employeeId, jobHistoryData) => {
    const response = await api.post(
      `${BASE_URL}/job-history/${employeeId}`,
      jobHistoryData
    );
    return response.data;
  },

  // Get job history by employee ID
  getJobHistory: async (employeeId) => {
    const response = await api.get(`${BASE_URL}/job-history/${employeeId}`);
    return response.data;
  },

  // Get all job history entries (admin/HR)
  getAllJobHistory: async (params = {}) => {
    const response = await api.get(`${BASE_URL}/job-history`, { params });
    return response.data;
  },

  // Update job history entry
  updateJobHistory: async (id, updateData) => {
    const response = await api.put(`${BASE_URL}/job-history/${id}`, updateData);
    return response.data;
  },

  // Delete job history entry
  deleteJobHistory: async (id) => {
    const response = await api.delete(`${BASE_URL}/job-history/${id}`);
    return response.data;
  },

  // Get current position
  getCurrentPosition: async (employeeId) => {
    const response = await api.get(
      `${BASE_URL}/job-history/${employeeId}/current`
    );
    return response.data;
  },

  // Get career progression
  getCareerProgression: async (employeeId) => {
    const response = await api.get(
      `${BASE_URL}/job-history/${employeeId}/career`
    );
    return response.data;
  },

  // Get performance history
  getPerformanceHistory: async (employeeId) => {
    const response = await api.get(
      `${BASE_URL}/job-history/${employeeId}/performance`
    );
    return response.data;
  },

  // Add performance review
  addPerformanceReview: async (id, reviewData) => {
    const response = await api.post(
      `${BASE_URL}/job-history/${id}/performance-review`,
      reviewData
    );
    return response.data;
  },
};

// Document Services
export const documentService = {
  // Upload document
  uploadDocument: async (employeeId, formData) => {
    const response = await api.post(
      `${BASE_URL}/documents/${employeeId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  },

  // Get documents by employee ID
  getDocuments: async (employeeId, params = {}) => {
    const response = await api.get(`${BASE_URL}/documents/${employeeId}`, {
      params,
    });
    return response.data;
  },

  // Get all documents (admin/HR)
  getAllDocuments: async (params = {}) => {
    const response = await api.get(`${BASE_URL}/documents`, { params });
    return response.data;
  },

  // Download document
  downloadDocument: async (id) => {
    const response = await api.get(`${BASE_URL}/documents/${id}/download`, {
      responseType: "blob",
    });
    return response;
  },

  // Update document
  updateDocument: async (id, formData) => {
    const response = await api.put(`${BASE_URL}/documents/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  },

  // Delete document
  deleteDocument: async (id) => {
    const response = await api.delete(`${BASE_URL}/documents/${id}`);
    return response.data;
  },

  // Verify document
  verifyDocument: async (id, verificationData) => {
    const response = await api.put(
      `${BASE_URL}/documents/${id}/verify`,
      verificationData
    );
    return response.data;
  },

  // Share document
  shareDocument: async (id, shareData) => {
    const response = await api.post(
      `${BASE_URL}/documents/${id}/share`,
      shareData
    );
    return response.data;
  },

  // Get document statistics
  getDocumentStats: async () => {
    const response = await api.get(`${BASE_URL}/documents/stats`);
    return response.data;
  },
};

// Combined Digital Files Service
export const digitalFilesService = {
  personalInfo: personalInfoService,
  jobHistory: jobHistoryService,
  documents: documentService,

  // Get all employees (for dashboard statistics)
  getAllEmployees: async () => {
    const response = await api.get("/api/v1/employees");
    return response.data;
  },
};
